/* Moteur de recherche pierres (site) — filtrage client-side (window.MM_STONES).
   Grammaire visuelle = écran 2 de la borne (needbar « Toutes »+besoins, cartes
   pierre flottantes) adaptée au web (grille verticale). Recherche par nom = liste
   déroulante scrollable -> clic direct sur la fiche /pages/pierre/<handle>.
   Filtre chakra RETIRÉ (décision 10/06). Borne = expérience à part (borne-kiosque.*). */
(function () {
  "use strict";
  var root = document.getElementById("rp");
  if (!root) return;

  // Données chargées depuis l'asset statique (84 pierres, sans le cap Liquid de 50).
  // Les familles de besoins viennent de mm-quiz-pierres.json, SOURCE UNIQUE
  // partagée avec le quiz et la borne : avant, ce tableau était recopié ici et
  // dans borne-kiosque.js, et une priorité corrigée d'un côté ne l'était pas de
  // l'autre. Si la config ne répond pas, la grille s'affiche quand même, sans
  // la barre de besoins : on perd un filtre, jamais le moteur.
  // Chargeur JSON PARTAGE avec le quiz (quiz-pierre.js) : les deux scripts lisent
  // les deux memes assets sur la meme page. Sans ce memo, mm-stones.json et
  // mm-quiz-pierres.json etaient demandes deux fois au chargement (mesure 11/09).
  window.MM_JSON = window.MM_JSON || {};
  function chargerJson(url) {
    if (!window.MM_JSON[url]) {
      window.MM_JSON[url] = fetch(url, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    }
    return window.MM_JSON[url];
  }
  function config() {
    if (!window.MM_QUIZ_CONFIG_URL) return Promise.resolve(null);
    return chargerJson(window.MM_QUIZ_CONFIG_URL)
      .then(function (c) { return (c && c.besoins) || null; })
      .catch(function () { return null; });
  }

  if (Array.isArray(window.MM_STONES) && window.MM_STONES.length) {
    config().then(function (b) { boot(window.MM_STONES, b); });
  } else if (window.MM_STONES_URL) {
    Promise.all([chargerJson(window.MM_STONES_URL), config()])
      .then(function (res) { boot(res[0], res[1]); })
      .catch(showLoadError);
  }

  // Échec de chargement des pierres : message visible plutôt qu'une page vide.
  function showLoadError() {
    var empty = document.getElementById("rp-empty");
    if (empty) {
      empty.textContent = "Les pierres ne s’affichent pas pour l’instant. Vérifiez votre connexion, puis réessayez dans quelques secondes.";
      empty.hidden = false;
    }
  }

  function norm(s) {
    return (s == null ? "" : String(s)).trim().toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "");
  }

  function boot(stones, besoins) {
    stones = stones || [];
    if (!stones.length) return;

  // Familles de besoins : lues dans assets/mm-quiz-pierres.json (cf. plus haut).
  // `exclude` retire une pierre d'un besoin, `top` la met en avant dans cet ordre.
  // Pour ajuster les priorités : éditer CE fichier-là, plus aucun .js.
  var BESOINS = besoins || [];
  // Garde : un seul fichier ecrit a la main alimente maintenant trois surfaces,
  // dont la borne en boutique. Un `keys` absent ne doit pas tuer le moteur.
  BESOINS.forEach(function (b) { b.nkeys = (b.keys || []).map(norm); });

  stones.forEach(function (s) {
    s._ints = (s.intention || []).map(norm);
    s._nom = norm(s.nom);
  });
  stones.sort(function (a, b) { return (a.nom || "").localeCompare(b.nom || "", "fr"); });

  var fBesoin = null, fText = "";

  function matchesBesoin(s, b) {
    if (b.exclude && b.exclude.indexOf(s.handle) !== -1) return false;
    return s._ints.some(function (i) { return b.nkeys.indexOf(i) !== -1; });
  }
  function visible(s) {
    if (fBesoin) { var b = BESOINS.filter(function (x) { return x.label === fBesoin; })[0]; if (!b || !matchesBesoin(s, b)) return false; }
    if (fText && s._nom.indexOf(norm(fText)) === -1) return false;
    return true;
  }

  var besoinsEl = document.getElementById("rp-besoins");
  var gridEl = document.getElementById("rp-grid");
  var countEl = document.getElementById("rp-count");
  var emptyEl = document.getElementById("rp-empty");
  var searchEl = document.getElementById("rp-search");
  var suggestEl = document.getElementById("rp-suggest");
  var wrapEl = searchEl.closest(".rp__searchwrap");
  var activeIdx = -1;

  function esc(t) { return (t == null ? "" : String(t)).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  // ---- needbar : « Toutes » + un besoin par pastille ----
  if (BESOINS.length) {
    besoinsEl.innerHTML = '<button type="button" class="rp__besoin" data-besoin="">Toutes</button>'
      + BESOINS.map(function (b) {
          return '<button type="button" class="rp__besoin" data-besoin="' + esc(b.label) + '">' + esc(b.label) + "</button>";
        }).join("");
  } else {
    besoinsEl.hidden = true;      // config absente : grille seule, pas de filtre mort
  }

  function card(s) {
    var img = s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.nom) + '" loading="lazy">' : '<span class="rp__noimg"></span>';
    var tags = (s.intention || []).slice(0, 3).map(function (t) { return esc(t.trim()); }).join(" · ");
    return '<a class="rp__card" href="/pages/pierre/' + esc(s.handle) + '">'
      + '<span class="rp__card-img">' + img + "</span>"
      + '<span class="rp__card-nom">' + esc(s.nom) + "</span>"
      + (tags ? '<span class="rp__card-tags">' + tags + "</span>" : "")
      + "</a>";
  }

  function render() {
    var b = fBesoin ? BESOINS.filter(function (x) { return x.label === fBesoin; })[0] : null;
    var top = (b && b.top) || [];
    var list = stones.filter(visible).sort(function (x, y) {
      var ix = top.indexOf(x.handle), iy = top.indexOf(y.handle);
      if (ix !== -1 || iy !== -1) {            // prioritaires en tête, dans l'ordre curé
        if (ix === -1) return 1;
        if (iy === -1) return -1;
        return ix - iy;
      }
      return (x.nom || "").localeCompare(y.nom || "", "fr");
    });
    gridEl.innerHTML = list.map(card).join("");
    countEl.textContent = list.length + (list.length > 1 ? " pierres" : " pierre");
    emptyEl.hidden = list.length > 0;
    Array.prototype.forEach.call(besoinsEl.children, function (el) { el.classList.toggle("is-active", (el.getAttribute("data-besoin") || null) === fBesoin); });
  }

  // ---- liste déroulante de recherche (scrollable, clic -> fiche) ----
  function renderSuggest() {
    var q = norm(searchEl.value);
    var list = q ? stones.filter(function (s) { return s._nom.indexOf(q) !== -1; }) : stones;
    if (!list.length) {
      suggestEl.innerHTML = '<p class="rp__sugg-empty">Aucune pierre à ce nom.</p>';
    } else {
      suggestEl.innerHTML = list.map(function (s, i) {
        var img = s.image
          ? '<img class="rp__sugg-img" src="' + esc(s.image) + '" alt="" loading="lazy">'
          : '<span class="rp__sugg-img rp__sugg-img--ph"></span>';
        return '<a class="rp__sugg" role="option" id="rp-opt-' + i + '" href="/pages/pierre/' + esc(s.handle) + '">'
          + img + '<span class="rp__sugg-nom">' + esc(s.nom) + "</span></a>";
      }).join("");
    }
    suggestEl.hidden = false;
    searchEl.setAttribute("aria-expanded", "true");
    activeIdx = -1;
    searchEl.removeAttribute("aria-activedescendant");
  }
  function closeSuggest() {
    suggestEl.hidden = true;
    searchEl.setAttribute("aria-expanded", "false");
    activeIdx = -1;
    searchEl.removeAttribute("aria-activedescendant");
  }

  besoinsEl.addEventListener("click", function (e) {
    var b = e.target.closest(".rp__besoin"); if (!b) return;
    var val = b.getAttribute("data-besoin") || null;     // "" (Toutes) -> null
    fBesoin = (val === fBesoin) ? null : val;
    render();
  });
  // Déplace la surbrillance clavier sur l'option idx (clampée) + aria-activedescendant.
  function setActive(idx) {
    var opts = suggestEl.querySelectorAll(".rp__sugg");
    if (!opts.length) return;
    idx = Math.max(0, Math.min(idx, opts.length - 1));
    activeIdx = idx;
    Array.prototype.forEach.call(opts, function (o, i) { o.classList.toggle("is-active", i === idx); });
    opts[idx].scrollIntoView({ block: "nearest" });
    searchEl.setAttribute("aria-activedescendant", opts[idx].id);
  }

  searchEl.addEventListener("focus", renderSuggest);
  searchEl.addEventListener("input", function () { fText = searchEl.value; render(); renderSuggest(); });
  searchEl.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeSuggest(); searchEl.blur(); return; }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (suggestEl.hidden) { renderSuggest(); setActive(0); } else { setActive(activeIdx + 1); }
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (!suggestEl.hidden) setActive(activeIdx - 1);
      return;
    }
    if (e.key === "Enter") {
      var opts = suggestEl.querySelectorAll(".rp__sugg");
      if (!suggestEl.hidden && activeIdx >= 0 && opts[activeIdx]) {
        e.preventDefault();
        window.location.href = opts[activeIdx].getAttribute("href");
      }
    }
  });
  // Ferme la liste seulement quand le focus quitte tout le bloc recherche (input +
  // suggestions) : permet Tab vers une suggestion sans que la liste disparaisse.
  if (wrapEl) {
    wrapEl.addEventListener("focusout", function (e) {
      if (!wrapEl.contains(e.relatedTarget)) closeSuggest();
    });
  }
  // Clic SOURIS sur une suggestion : empêche le blur de l'input (Safari/iOS ne
  // focus pas les <a> au clic → sans ça, focusout fermerait la liste avant que le
  // clic aboutisse). preventDefault sur mousedown garde le focus ; le <a> navigue
  // quand même au click. Le clavier (Tab/flèches/Enter) reste géré à part.
  suggestEl.addEventListener("mousedown", function (e) {
    if (e.target.closest(".rp__sugg")) e.preventDefault();
  });

  render();
  }
})();
